import { render, staticRenderFns } from "./HeadquartersImport.vue?vue&type=template&id=00c23fb6&scoped=true&"
import script from "./HeadquartersImport.vue?vue&type=script&lang=js&"
export * from "./HeadquartersImport.vue?vue&type=script&lang=js&"
import style0 from "./HeadquartersImport.vue?vue&type=style&index=0&id=00c23fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c23fb6",
  null
  
)

component.options.__file = "HeadquartersImport.vue"
export default component.exports